import * as Sentry from "@sentry/nuxt"
import { store } from "~/composables/userStore"

export { SentrySdkLive, WebSdkLive } from "#components/observability/otelLayers"

type Primitive = number | string | boolean | bigint | symbol | null | undefined
export const annotateTags = (tags: { [key: string]: Primitive }) => {
  // tags["device.id"] = deviceId
  tags["user.displayName"] = store.user
    ? `${store.user.name.firstName} ${store.user.name.lastName}`
    : undefined
  tags["user.id"] = store.user?.id
}
// import {
//   ConsoleSpanExporter,
//   SimpleSpanProcessor,
// } from "@opentelemetry/tracing"
// import { CollectorTraceExporter } from "@opentelemetry/exporter-collector"
// import { WebTracerProvider } from "@opentelemetry/web"
// import { ZoneContextManager } from "@opentelemetry/context-zone"
// import { B3Propagator } from "@opentelemetry/propagator-b3"

// const provider = new WebTracerProvider()

// // Configure a span processor and exporter for the tracer
// provider.addSpanProcessor(new SimpleSpanProcessor(new ConsoleSpanExporter()))
// provider.addSpanProcessor(new SimpleSpanProcessor(new CollectorTraceExporter())) // url is optional and can be omitted - default is http://localhost:55681/v1/trace

// provider.register({
//   contextManager: new ZoneContextManager(),
//   propagator: new B3Propagator(),
// })

watch(
  store,
  ({ user }) => {
    Sentry.setUser(
      user
        ? {
          id: user.id,
          displayName: `${user.name.firstName} ${user.name.lastName}`
        }
        : null
    )
  },
  { immediate: true }
)

// registerInstrumentations({
//   instrumentations: [
//     new FetchInstrumentation({
//      // client is running on port 1234
//       ignoreUrls: [/localhost:1234\/sockjs-node/],
//       propagateTraceHeaderCorsUrls: ['http://localhost:7777'],
//       clearTimingResources: true,
//     }),
//   ],
// });

// const webTracer = provider.getTracer('tracer-web');
// const singleSpan = webTracer.startSpan(`fetch-span-start`);

// context.with(setSpan(context.active(), singleSpan), () => {
//   // ping an endpoint
//   fetch('http://localhost:7777/hello', {
//     method: 'GET',
//     headers: {
//       'Accept': 'application/json',
//       'Content-Type': 'application/json',
//     },
//   });
//     singleSpan.end();
// });
